export default __webpack_public_path__ + "e769b666cd0a0b924be3dfced7729942.webp";